import * as jsxRuntime from "/home/runner/work/LANDR.Web.Samples/LANDR.Web.Samples/packages/samples-fe/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment